<template>
  <div class="all-requests">
    <div
      v-if="exportInProgress"
      class="export-excel-banner pa-3 mb-3 rounded"
      style="
        border: 1px solid rgba(63, 14, 64, 0.25);
        background: rgba(63, 14, 64, 0.06);
        width: calc(100% - 6px);
        margin-left: 3px;
      "
    >
      <div class="caption primary--text text-center font-weight-bold mb-2">
        جاري تجهيز ملف Excel للتصدير… عند الانتهاء سيظهر تنبيه بزر التحميل
      </div>
      <v-progress-linear indeterminate color="primary" height="10" rounded />
    </div>
    <div
      class="printing mb-3"
      style="
        background: white;
        padding: 4px;
        border-radius: 4px !important;
        margin-bottom: 30px !important;
        height: 52px;
        margin-top: 25px;
        display: flex;
        border: 1px solid #ececec;
        margin-left: 3px;
      "
      :style="items.length <= 0 ? 'display:none' : 'display:flex'"
    >
      <div>

        <!-- <v-btn
          depressed
          width="40"
          height="40"
          :color="$vuetify.theme.themes.light.dataActionBTN"
          dark
          fab
          class="ml-1 hidden-sm-and-down"
          @click="exportExcel"
          :loading="exportInProgress"
          :disabled="exportInProgress"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.116"
            height="18.116"
            viewBox="0 0 12.25 14"
          >
            <g id="excel-file" transform="translate(-1.5)">
              <path
                id="Path_4097"
                data-name="Path 4097"
                d="M11.708,14H1.792a.292.292,0,0,1-.292-.292V3.548a.292.292,0,0,1,.074-.194L4.491.1A.292.292,0,0,1,4.708,0h7A.292.292,0,0,1,12,.292V7a.292.292,0,0,1-.583,0V.583H4.839L2.083,3.659v9.757h9.333V12.25a.292.292,0,1,1,.583,0v1.458A.293.293,0,0,1,11.708,14Z"
                fill="#fff"
              />
              <path
                id="Path_4098"
                data-name="Path 4098"
                d="M4.917,4.292H2.292a.292.292,0,0,1,0-.583H4.625V.792a.292.292,0,0,1,.583,0V4A.292.292,0,0,1,4.917,4.292Zm8.167,8.167h-7a.876.876,0,0,1-.875-.875v-3.5a.876.876,0,0,1,.875-.875h7a.876.876,0,0,1,.875.875v3.5A.876.876,0,0,1,13.083,12.458Zm-7-4.667a.292.292,0,0,0-.292.292v3.5a.292.292,0,0,0,.292.292h7a.293.293,0,0,0,.292-.292v-3.5a.293.293,0,0,0-.292-.292Z"
                transform="translate(-0.208 -0.208)"
                fill="#fff"
              />
              <path
                id="Path_4099"
                data-name="Path 4099"
                d="M11.29,15.67,10.566,14.6h.3a.075.075,0,0,1,.047.012.1.1,0,0,1,.027.03l.572.878a.4.4,0,0,1,.032-.07l.54-.8a.186.186,0,0,1,.03-.036.058.058,0,0,1,.039-.012h.283l-.726,1.052.751,1.139h-.293a.079.079,0,0,1-.053-.017.176.176,0,0,1-.031-.038l-.588-.919a.316.316,0,0,1-.027.061l-.572.858a.21.21,0,0,1-.032.039.065.065,0,0,1-.05.018h-.275l.755-1.125Zm1.754.876h.948V16.8H12.747V14.6h.3Zm2.4-1.6a.117.117,0,0,1-.03.034.059.059,0,0,1-.039.012.111.111,0,0,1-.061-.026q-.042-.031-.086-.058a.805.805,0,0,0-.128-.057.558.558,0,0,0-.18-.026.575.575,0,0,0-.176.027.377.377,0,0,0-.128.073.279.279,0,0,0-.076.109.348.348,0,0,0-.026.134.243.243,0,0,0,.045.152.385.385,0,0,0,.119.1.952.952,0,0,0,.168.074l.193.065c.065.023.131.048.192.075a.658.658,0,0,1,.168.107.486.486,0,0,1,.12.158.515.515,0,0,1,.045.229.735.735,0,0,1-.049.269.632.632,0,0,1-.143.22.672.672,0,0,1-.231.146.849.849,0,0,1-.311.054.956.956,0,0,1-.389-.077.908.908,0,0,1-.3-.209l.086-.14a.107.107,0,0,1,.03-.029.07.07,0,0,1,.038-.012.118.118,0,0,1,.073.034.946.946,0,0,0,.1.076.608.608,0,0,0,.366.107.577.577,0,0,0,.188-.029.378.378,0,0,0,.258-.373.269.269,0,0,0-.045-.163.38.38,0,0,0-.118-.106.832.832,0,0,0-.167-.072l-.192-.061a2.009,2.009,0,0,1-.192-.073.608.608,0,0,1-.167-.109.484.484,0,0,1-.118-.164.571.571,0,0,1-.045-.244.579.579,0,0,1,.177-.418.622.622,0,0,1,.211-.134.75.75,0,0,1,.29-.05.921.921,0,0,1,.335.058.773.773,0,0,1,.264.169l-.072.141Z"
                transform="translate(-3.765 -6.075)"
                fill="#fff"
              />
            </g>
          </svg>
        </v-btn> -->


        <v-btn
          depressed
          width="40"
          height="40"
          :color="$vuetify.theme.themes.light.dataActionBTN"
          dark
          fab
          class="ml-1 hidden-sm-and-down"
          title="excel"
          @click="exportExcelFrontend"
          :disabled="
            !items.length ||
            ($store.state.views !== 'table' && $store.state.views !== 'default')
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.116"
            height="18.116"
            viewBox="0 0 12.25 14"
          >
            <g id="excel-file-front" transform="translate(-1.5)">
              <path
                d="M11.708,14H1.792a.292.292,0,0,1-.292-.292V3.548a.292.292,0,0,1,.074-.194L4.491.1A.292.292,0,0,1,4.708,0h7A.292.292,0,0,1,12,.292V7a.292.292,0,0,1-.583,0V.583H4.839L2.083,3.659v9.757h9.333V12.25a.292.292,0,1,1,.583,0v1.458A.293.293,0,0,1,11.708,14Z"
                fill="#fff"
              />
              <path
                d="M4.917,4.292H2.292a.292.292,0,0,1,0-.583H4.625V.792a.292.292,0,0,1,.583,0V4A.292.292,0,0,1,4.917,4.292Zm8.167,8.167h-7a.876.876,0,0,1-.875-.875v-3.5a.876.876,0,0,1,.875-.875h7a.876.876,0,0,1,.875.875v3.5A.876.876,0,0,1,13.083,12.458Zm-7-4.667a.292.292,0,0,0-.292.292v3.5a.292.292,0,0,0,.292.292h7a.293.293,0,0,0,.292-.292v-3.5a.293.293,0,0,0-.292-.292Z"
                transform="translate(-0.208 -0.208)"
                fill="#fff"
              />
              <path
                d="M11.29,15.67,10.566,14.6h.3a.075.075,0,0,1,.047.012.1.1,0,0,1,.027.03l.572.878a.4.4,0,0,1,.032-.07l.54-.8a.186.186,0,0,1,.03-.036.058.058,0,0,1,.039-.012h.283l-.726,1.052.751,1.139h-.293a.079.079,0,0,1-.053-.017.176.176,0,0,1-.031-.038l-.588-.919a.316.316,0,0,1-.027.061l-.572.858a.21.21,0,0,1-.032.039.065.065,0,0,1-.05.018h-.275l.755-1.125Zm1.754.876h.948V16.8H12.747V14.6h.3Zm2.4-1.6a.117.117,0,0,1-.03.034.059.059,0,0,1-.039.012.111.111,0,0,1-.061-.026q-.042-.031-.086-.058a.805.805,0,0,0-.128-.057.558.558,0,0,0-.18-.026.575.575,0,0,0-.176.027.377.377,0,0,0-.128.073.279.279,0,0,0-.076.109.348.348,0,0,0,.026.134.243.243,0,0,0,.045.152.385.385,0,0,0,.119.1.952.952,0,0,0,.168.074l.193.065c.065.023.131.048.192.075a.658.658,0,0,1,.168.107.486.486,0,0,1,.12.158.515.515,0,0,1,.045.229.735.735,0,0,1-.049.269.632.632,0,0,1-.143.22.672.672,0,0,1-.231.146.849.849,0,0,1-.311.054.956.956,0,0,1-.389-.077.908.908,0,0,1-.3-.209l.086-.14a.107.107,0,0,1,.03-.029.07.07,0,0,1,.038-.012.118.118,0,0,1,.073.034.946.946,0,0,0,.1.076.608.608,0,0,0,.366.107.577.577,0,0,0,.188-.029.378.378,0,0,0,.258-.373.269.269,0,0,0-.045-.163.38.38,0,0,0-.118-.106.832.832,0,0,0-.167-.072l-.192-.061a2.009,2.009,0,0,1-.192-.073.608.608,0,0,1-.167-.109.484.484,0,0,1-.118-.164.571.571,0,0,1,.045-.244.579.579,0,0,1,.177-.418.622.622,0,0,1,.211-.134.75.75,0,0,1,.29-.05.921.921,0,0,1,.335.058.773.773,0,0,1,.264.169l-.072.141Z"
                transform="translate(-3.765 -6.075)"
                fill="#fff"
              />
            </g>
          </svg>
        </v-btn>
        <v-btn
          depressed
          width="42"
          height="42"
          @click="printNow"
          :color="$vuetify.theme.themes.light.dataActionBTN"
          fab
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.116"
            height="18.116"
            viewBox="0 0 16.116 16.116"
          >
            <g
              id="Icon_feather-printer"
              data-name="Icon feather-printer"
              transform="translate(-2.5 -2.5)"
            >
              <path
                id="Path_4011"
                data-name="Path 4011"
                d="M9,8.291V3h9.069V8.291"
                transform="translate(-2.977)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4012"
                data-name="Path 4012"
                d="M6.023,20.3H4.512A1.512,1.512,0,0,1,3,18.791V15.012A1.512,1.512,0,0,1,4.512,13.5H16.6a1.512,1.512,0,0,1,1.512,1.512v3.779A1.512,1.512,0,0,1,16.6,20.3H15.093"
                transform="translate(0 -5.209)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_4013"
                data-name="Path 4013"
                d="M9,21h9.069v6.046H9Z"
                transform="translate(-2.977 -8.931)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </v-btn>
        <v-spacer class="top-spacer" />
      </div>
    </div>
    <SMEAllRequestsFilterDialog pageName="all" @search-result="handleSearchResult" @clear-search="handleClearSearch" />
    <div class="table__view">
      <table-component
        :showSelect="true"
        :pagination="pagination"
        :limit="$store.state.counterOfShow"
        itemKey="id"
        :selectedRows.sync="selected_requests"
        @refresh="refreshTable"
        :headers="headers"
        :items="items"
        :loading="loading"
        v-model="page"
        v-if="$store.state.views == 'table' || $store.state.views == 'default'"
      >
        <!-- eslint-disable -->
        <template v-slot:[`item.action`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#3f0e40" depressed small dark v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="to_request_details(item)">
                <v-list-item-icon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.528"
                    height="15.111"
                    viewBox="0 0 13.528 10.111"
                  >
                    <g
                      id="Icon_feather-eye-dark"
                      data-name="Icon feather-eye-dark"
                      transform="translate(-1 -5.5)"
                    >
                      <path
                        id="Path_4040"
                        data-name="Path 4040"
                        d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                        fill="none"
                        :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                      />
                      <path
                        id="Path_4041"
                        data-name="Path 4041"
                        d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                        transform="translate(-7.444 -4.653)"
                        fill="none"
                        :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                      />
                    </g>
                  </svg>
                </v-list-item-icon>
                <v-list-item-title>فتح</v-list-item-title>
              </v-list-item>

              <router-link style="text-decoration: none" target="_blank"
                :to="{ name: 'salesManager_request_details', params: { id: item.id } }">
                <v-list-item>
                  <v-list-item-icon class="ml-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.528" height="15.111" viewBox="0 0 13.528 10.111">
                      <g id="Icon_feather-eye-dark" data-name="Icon feather-eye-dark" transform="translate(-1 -5.5)">
                        <path id="Path_4040" data-name="Path 4040"
                          d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                          fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                        <path id="Path_4041" data-name="Path 4041"
                          d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                          transform="translate(-7.444 -4.653)" fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="1" />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title> فتح في تاب جديد</v-list-item-title>
                </v-list-item>
              </router-link>

            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.class_id_quality`]="{ item }">
          {{ item.class_id_quality ? "نعم" : "لا" }}
        </template>
        <template slot="item.agent_date" slot-scope="props">
          <div>{{ props.item.agent_date.split(" ")[0] }}</div>
          <div>{{ props.item.agent_date.split(" ")[1].split(".")[0] }}</div>
        </template>
        <template slot="item.agent_notes" slot-scope="props">
          <span v-if="!props.item.agent_notes"></span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.item.agent_notes.substring(0, 25) + "..." }}</span>
            </template>
            <div class="font-weight-bold">{{ props.item.agent_notes }}</div>
          </v-tooltip>
        </template>
        <template slot="item.quality_notes" slot-scope="props">
          <span v-if="!props.item.quality_notes"></span>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{
                props.item.quality_notes.substring(0, 25) + "..."
              }}</span>
            </template>
            <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
          </v-tooltip>
        </template>
        <template slot="item.req_product_type" slot-scope="props">
          <span v-if="props.item.req_product_type && props.item.req_product_type !== 'لا_يوجد'">
            {{
              ($store.state.selected_products || []).find(
                (p) => p.id === props.item.req_product_type
              )?.value || props.item.req_product_type
            }}
          </span>
          <span v-else style="color: red">
            {{ props.item.req_product_type || 'لا_يوجد' }}
          </span>
        </template>
        <template slot="item.source" slot-scope="props">
          {{ props.item.source_text
          }}{{ props.item.source == 2 ? ` - ${props.item.collaborator_name}` : "" }}
        </template>
        <template slot="item.customer_name" slot-scope="props">
          {{ props.item.customer.name }}
        </template>

        <template slot="item.agent_name" slot-scope="props">
          {{ props.item.user.name }}
        </template>
        <template slot="item.updated_at" slot-scope="props">
          <div>
            {{
              props.item.updated_at != null && props.item.updated_at !== undefined
                ? props.item.updated_at.split("T")[0]
                : ""
            }}
          </div>
          <div>
            {{
              props.item.updated_at != null && props.item.updated_at !== undefined
                ? props.item.updated_at.split("T")[1]?.split(".")[0]
                : ""
            }}
          </div>
        </template>
      </table-component>
    </div>
    <!-- Cards -->
    <CardsStyle
        v-if="$store.state.views == 'cards'"
      :tableData="items"
      :endPoint="`${this.$store.state.url}/v2/employee/all-requestes-of-consultants`"
    />
    <!-- Cards -->
    <!-- <AddNewRequestBtn/> -->
    <v-snackbar v-model="exportDoneSnackbar" :timeout="35000" bottom multi-line>
      <span>{{ exportSnackbarMessage }}</span>
      <v-btn color="primary" text slot="action" @click="openExportDownloadManually">
        تحميل الملف
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";
import CardsStyle from "@/components/Base/sales_manager/RelatedAgentsCardsStyle.vue";
import SMEAllRequestsFilterDialog from "./SMEAllRequestsFilterDialog.vue";
// import AddNewRequestBtn from "../../Charts/AddNewRequestBtn.vue";
export default {
  name: "HelloWorld",
  components: { CardsStyle, SMEAllRequestsFilterDialog },
  data: () => ({
    loading: false,
    pagination: {},
    headers: [
      { text: "تاريخ الطلب", value: "req_date", align: "center", width: "120px" },
      // { text: "نوع الطلب", value: "type", align: "center" },
      { text: "نوع المنتج", value: "req_product_type", align: "center" },
      { text: "عميل", value: "customer_name", align: "center" },
      { text: "اسم الاستشاري", value: "agent_name", align: "center" },
      { text: "حالة الطلب", value: "status", align: "center" },
      { text: "مصدر المعامله", value: "source", align: "center", width: "120px" },
      { text: "تصنيف المعامله", value: "class_id_agent_text", align: "center" },
      { text: "ملاحظة الاستشاري", value: "agent_notes", align: "center" },
      { text: "ملاحظة الجوده", value: "quality_notes", align: "center" },
      { text: "تاريخ الاستشاري", value: "agent_date", align: "center", width: "120px" },
      {
        text: " هل تم استلامة من قبل الجودة",
        value: "class_id_quality",
        align: "center",
      },
      { text: "تاريخ تحديث الطلب", value: "updated_at", align: "center", width: "120px" },
      { text: "العمليات", value: "action", align: "center" },
    ],
    page: 1,
    /* eslint-disable */
    items: [],
    addNewRequestDialog: false,
    selected_requests: [],
    exportInProgress: false,
    exportPollInterval: null,
    exportPollBusy: false,
    exportDoneSnackbar: false,
    exportSnackbarMessage: "",
    exportDoneUrl: "",
    skipPageWatch: false,
  }),
  methods: {
    searchRequest(page, type) {
      this.loading = true;
      const perPage = Number(this.$store.state.counterOfShow);
      if (page > 1 || type === "table") {
        if (
          this.$store.state.bodySearch &&
          typeof this.$store.state.bodySearch.delete === "function"
        ) {
          this.$store.state.bodySearch.delete("page");
          this.$store.state.bodySearch.append("page", page);
        }
        const url = `${this.$store.state.url}/sales/agentsRequest/search?type=all&per_page=${perPage}`;
        axiosInstance
          .post(url, this.$store.state.bodySearch, {
            headers: this.request_headers(),
          })
          .then((res) => {
            this.items = res.data.payload.data;
            this.pagination = {
              limit: perPage,
              count:
                res.data.payload.count_of_all ||
                res.data.payload.searched ||
                this.items.length,
            };
            this.loading = false;
          })
          .catch((err) => {
            console.error("searchRequest:", err);
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    refreshTable() {
      if (this.$store.state.isSearch === false) {
        this.get_all_requests(this.page);
      } else {
        this.searchRequest(this.page, "table");
      }
    },
    async get_all_requests(page = 1) {
      this.loading = true;
      const perPage = Number(this.$store.state.counterOfShow);
      await Axios.get(
        `${this.$store.state.url}/v2/employee/all-requestes-of-consultants?type=all&page=${page}&per_page=${perPage}`,
        {
          headers: this.request_headers(),
        }
      ).then((response) => {
        this.items = response.data.payload.data;
        this.pagination = {
          limit: perPage,
          count: response.data.payload.count_of_all,
        };
        this.loading = false;
      });
    },
    to_request_details(item) {
      this.$router.push({
        name: "salesManager_request_details",
        params: { id: item.id },
      });
    },
    to_tickets_page(item) {
      this.$router.push({ name: "tickets", params: { id: item.id } });
    },
    duplicateFormData(source) {
      const copy = new FormData();
      if (!source || typeof source.entries !== "function") {
        return copy;
      }
      for (const [k, v] of source.entries()) {
        copy.append(k, v);
      }
      return copy;
    },
    stopExportPolling() {
      if (this.exportPollInterval) {
        clearInterval(this.exportPollInterval);
        this.exportPollInterval = null;
      }
      this.exportPollBusy = false;
    },
    resolveExportDownloadHref(href) {
      if (!href) return "";
      if (/^https?:\/\//i.test(href)) return href;
      const base = String(this.$store.state.url || "").replace(/\/$/, "");
      const path = href.startsWith("/") ? href : `/${href}`;
      return `${base}${path}`;
    },
    onExportFinished(downloadUrlRaw) {
      this.exportDoneUrl = this.resolveExportDownloadHref(downloadUrlRaw);
      this.exportSnackbarMessage = "تم تجهيز ملف Excel. اضغط «تحميل الملف» للتنزيل.";
      this.exportDoneSnackbar = true;
    },
    openExportDownloadManually() {
      if (!this.exportDoneUrl) return;
      window.open(this.exportDoneUrl, "_blank");
    },
    exportExcelFrontend() {
      // const table = this.$el.querySelector(".table__view table");
      // if (!table) return;
      // this.exportTableToCsv(table, "جميع الطلبات");


      const XLSX = require("xlsx");
      const products = this.$store.state.selected_products || [];
      const rows = this.items.map((item) => {
        const product = products.find((p) => p.id === item.req_product_type);
        const updatedAtDate =
          item.updated_at != null && item.updated_at !== undefined
            ? item.updated_at.split("T")[0]
            : "";
        const updatedAtTime =
          item.updated_at != null && item.updated_at !== undefined
            ? item.updated_at.split("T")[1]?.split(".")[0] || ""
            : "";
        return {
          "تاريخ الطلب": item.req_date || "",
          "نوع المنتج":
            product?.value ||
            (item.req_product_type && item.req_product_type !== "لا_يوجد"
              ? item.req_product_type
              : item.req_product_type || "لا_يوجد"),
          عميل: item.customer?.name || "",
          "اسم الاستشاري": item.user?.name || "",
          "حالة الطلب": item.status || "",
          "مصدر المعامله": `${item.source_text || ""}${
            item.source == 2 ? ` - ${item.collaborator_name || ""}` : ""
          }`,
          "تصنيف المعامله": item.class_id_agent_text || "",
          "ملاحظة الاستشاري": item.agent_notes || "",
          "ملاحظة الجوده": item.quality_notes || "",
          "تاريخ الاستشاري":
            item.agent_date && item.agent_date.split(" ")[1]
              ? `${item.agent_date.split(" ")[0]} ${
                  item.agent_date.split(" ")[1].split(".")[0]
                }`
              : item.agent_date || "",
          " هل تم استلامة من قبل الجودة": item.class_id_quality ? "نعم" : "لا",
          "تاريخ تحديث الطلب": `${updatedAtDate} ${updatedAtTime}`.trim(),
        };
      });
      const sheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, "Requests");
      XLSX.writeFile(workbook, `all-requests-${new Date().toISOString().slice(0, 10)}.xlsx`);

    },
    async exportExcel() {
      if (this.exportInProgress || !this.items.length) {
        return;
      }
      this.exportDoneSnackbar = false;
      this.exportDoneUrl = "";
      this.exportSnackbarMessage = "";
      this.exportInProgress = true;
      this.stopExportPolling();
      try {
        const url = `${this.$store.state.url}/v2/employee/all-requestes-of-consultants/export`;
        const body = new FormData();
        const useFilters =
          this.$store.state.isSearch &&
          this.$store.state.bodySearch &&
          typeof this.$store.state.bodySearch.entries === "function";
        body.append("apply_filters", useFilters ? "1" : "0");
        if (useFilters) {
          const cloned = this.duplicateFormData(this.$store.state.bodySearch);
          for (const [k, v] of cloned.entries()) {
            body.append(k, v);
          }
        }

        const res = await Axios.post(url, body, {
          headers: this.request_headers(),
        });
        const exportId =
          res.data && res.data.payload && res.data.payload.export_id
            ? res.data.payload.export_id
            : null;
        if (!exportId) {
          throw new Error("missing export id");
        }

        await new Promise((resolve, reject) => {
          let settled = false;
          const deadline = Date.now() + 10 * 60 * 1000;

          const tick = async () => {
            if (settled || this.exportPollBusy) return;
            if (Date.now() > deadline) {
              settled = true;
              this.stopExportPolling();
              reject(new Error("انتهى وقت انتظار التصدير"));
              return;
            }
            this.exportPollBusy = true;
            try {
              const st = await Axios.get(
                `${this.$store.state.url}/v2/employee/all-requestes-of-consultants/export-status?export_id=${exportId}`,
                { headers: this.request_headers() }
              );
              const p = st.data.payload || {};
              if (p.status === "completed" && p.download_url) {
                settled = true;
                this.stopExportPolling();
                this.onExportFinished(p.download_url);
                resolve();
              } else if (p.status === "failed") {
                settled = true;
                this.stopExportPolling();
                reject(new Error(p.message || "export failed"));
              }
            } catch (e) {
              if (!settled) {
                settled = true;
                this.stopExportPolling();
                reject(e);
              }
            } finally {
              this.exportPollBusy = false;
            }
          };

          tick();
          this.exportPollInterval = setInterval(() => tick(), 2200);
        });
      } catch (e) {
        console.error("Export excel:", e);
      } finally {
        this.exportInProgress = false;
      }
    },
    printNow() {
      const products = this.$store.state.selected_products || [];
      this.items.forEach((data) => {
        data.customer_name = data.customer.name;
        const prod = products.find((p) => p.id === data.req_product_type);
        data.req_product_type = prod ? prod.value : (data.req_product_type || "لا_يوجد");
      });
      this.printTable(this.items, this.headers, "جدول جميع الطلبات");
    },
    to_chat_page(item) {
      this.$router.push({
        name: "chat_component",
        query: {
          customer_name: item.customer.name,
          customer_id: item.customer.id,
          request_id: item.id,
        },
      });
    },
    handleSearchResult(data, count) {
      this.isSearchActive = true;
      this.items = data;
      const perPage = Number(this.$store.state.counterOfShow);
      this.pagination = {
        limit: perPage,
        count: count || data.length,
      };
      this.loading = false;
      if (this.page !== 1) {
        this.skipPageWatch = true;
        this.page = 1;
        this.$nextTick(() => {
          this.skipPageWatch = false;
        });
      }
    },
    handleClearSearch() {
      this.$store.state.isSearch = false;
      this.$store.state.bodySearch = new FormData();
      this.skipPageWatch = true;
      this.page = 1;
      this.$nextTick(() => {
        this.skipPageWatch = false;
      });
      this.get_all_requests(1);
    },
  },
  beforeDestroy() {
    this.stopExportPolling();
  },
  async created() {
    this.$store.state.isSearch = false;
    await this.get_all_requests();
  },
  mounted(){
    this.$store.state.views = 'table';
  },
  watch: {
    "$store.state.rates_in_admin_count": {
      handler(val) {
        if (val > this.$store.state.redirect_count_of_rates && localStorage["role"] == "1") {
          this.$store.state.showAlertOfRatingDidntProccess = true;
          this.$router.push({ name: "salesManager_SMRateServices" });
        }
      },
      immediate: true
    },

    page(val) {
      if (this.skipPageWatch) return;
      if (this.$store.state.isSearch === false) {
        this.get_all_requests(val);
      } else {
        this.searchRequest(val, "table");
      }
    },
    selected_requests(val) {
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.$store.state.isSearch === false) {
            this.get_all_requests(this.page);
          } else {
            this.searchRequest(this.page, "table");
          }
        }
      },
    },

    $route: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },
};
</script>
